export default "__VITE_ASSET__BJ7133B2__"